import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';

const NavigationBar = ({ mode }) => {
    const location = useLocation();

    const getButtonStyle = (path) => ({
        textDecoration: 'none',
        backgroundColor: location.pathname === path ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
        fontWeight: location.pathname === path ? 'bold' : 'normal'
    });

    return (
        <AppBar position="static" color="default">
            <Toolbar>
                <Typography variant="h6" style={{ flexGrow: 1 }}>
                    TS Service
                </Typography>
                <Button
                    color="inherit"
                    component={Link}
                    to="/dashboard"
                    style={getButtonStyle('/dashboard')}
                >
                    Analytics Dashboard
                </Button>
                <Button
                    color="inherit"
                    component={Link}
                    to="/job-manager"
                    style={getButtonStyle('/job-manager')}
                >
                    Job Manager
                </Button>
                <Button
                    color="inherit"
                    component={Link}
                    to="/file_manager"
                    style={getButtonStyle('/file_manager')}
                >
                    File Manager
                </Button>
            </Toolbar>
        </AppBar>
    );
};

export default NavigationBar;
